import { useSyncExternalStore } from "react";
import messages from "./messages.json";

export type Locale = "pt-BR" | "en-US";
const STORAGE_KEY = "pingys-locale";
const listeners = new Set<() => void>();
function readPreference(): Locale {
  if (typeof window === "undefined") return "pt-BR";
  try { return window.localStorage.getItem(STORAGE_KEY) === "en-US" ? "en-US" : "pt-BR"; }
  catch { return "pt-BR"; }
}
let locale: Locale = readPreference();
export function getLocale() { return locale; }
function applyLocale(next: Locale) {
  locale = next;
  if (typeof document !== "undefined") document.documentElement.lang = next;
  listeners.forEach(listener => listener());
}
export function setLocale(next: Locale) {
  try { window.localStorage.setItem(STORAGE_KEY, next); } catch { /* Storage may be unavailable in private browsing. */ }
  applyLocale(next);
}
if (typeof window !== "undefined") {
  document.documentElement.lang = locale;
  window.addEventListener("storage", event => {
    if (event.key === STORAGE_KEY || event.key === null) applyLocale(readPreference());
  });
}
export function useLocale() {
  return useSyncExternalStore(listener => { listeners.add(listener); return () => { listeners.delete(listener); }; }, getLocale, () => "pt-BR" as Locale);
}
/** UI copy only: API identifiers and user-authored content must remain unchanged. */
export function t(message: string, values: Record<string | number, string | number | undefined> = {}): string {
  const entry = (messages as Record<string, string[]>)[message];
  const translated = entry?.[locale === "pt-BR" ? 0 : 1] ?? message;
  return translated.replace(/\{(\w+)\}/g, (token, key: string) => Object.hasOwn(values, key) ? String(values[key]) : token);
}
